import { Box, HStack, Icon, Text, chakra } from "@chakra-ui/react";
import { FaUser } from "react-icons/fa";
import { DeleteConfirmationModal } from "../../../../components/DeleteConfirmationModal";

export default function DeleteContactModal({
  isOpen,
  onClose,
  onDelete,
  email,
  loading = false,
}: {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  email: string;
  loading?: boolean;
}) {
  return (
    <DeleteConfirmationModal
      isOpen={isOpen}
      onCancel={onClose}
      submitHandler={onDelete}
      loading={loading}
    >
      <Text>Are you sure you want to delete this contact?</Text>
      <HStack mt={3} color="brand.black" wordBreak="break-word">
        <Icon as={FaUser} />
        <Text>{email}</Text>
      </HStack>
      <Box mt={3} p={2} bgColor="gray.100" fontSize="sm">
        <chakra.span fontWeight="600" mr={1}>
          Note:
        </chakra.span>
        Deleting the contact will only remove the contact's details. This will
        not remove the product data assoicated with the email address.
      </Box>
    </DeleteConfirmationModal>
  );
}
